module.exports = __webpack_public_path__ + "static/media/pic.c598326e.jpg";